import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Mail } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8">
          {/* Brand */}
          <div className="md:col-span-4">
            <h3 className="font-serif text-2xl text-[#F5F5F0] mb-3">
              Phaeton Imagery
            </h3>
            <p className="text-[#525252] text-xs font-mono tracking-wider">
              by Akanni
            </p>
          </div>

          {/* Navigation */}
          <div className="md:col-span-2">
            <nav className="space-y-2">
              <Link to="/gallery" className="block footer-link text-xs font-mono uppercase tracking-wider" data-testid="footer-gallery">Exhibitions</Link>
              <Link to="/shop" className="block footer-link text-xs font-mono uppercase tracking-wider" data-testid="footer-shop">Shop</Link>
              <Link to="/auction" className="block footer-link text-xs font-mono uppercase tracking-wider" data-testid="footer-auction">Auction</Link>
              <Link to="/about" className="block footer-link text-xs font-mono uppercase tracking-wider" data-testid="footer-about">About</Link>
              <Link to="/news" className="block footer-link text-xs font-mono uppercase tracking-wider" data-testid="footer-news">News</Link>
              <Link to="/contact" className="block footer-link text-xs font-mono uppercase tracking-wider" data-testid="footer-contact">Contact Us</Link>
            </nav>
          </div>

          {/* Social */}
          <div className="md:col-span-3">
            <div className="flex gap-3">
              <a href="https://instagram.com/phaetonimagery" target="_blank" rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center text-[#525252] hover:text-[#C5A059] transition-colors" data-testid="footer-instagram">
                <Instagram size={16} strokeWidth={1.5} />
              </a>
              <a href="https://twitter.com/phaetonimagery" target="_blank" rel="noopener noreferrer"
                className="w-8 h-8 flex items-center justify-center text-[#525252] hover:text-[#C5A059] transition-colors" data-testid="footer-twitter">
                <Twitter size={16} strokeWidth={1.5} />
              </a>
              <a href="mailto:gabodunrin@gmail.com"
                className="w-8 h-8 flex items-center justify-center text-[#525252] hover:text-[#C5A059] transition-colors" data-testid="footer-email">
                <Mail size={16} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          {/* Copyright */}
          <div className="md:col-span-3 md:text-right">
            <p className="text-[#525252] text-[10px] font-mono tracking-wider">
              &copy; {new Date().getFullYear()} Phaeton Imagery
            </p>
            <p className="text-[#525252] text-[10px] font-mono tracking-wider mt-1">
              All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
